import React from "react";
import EntriesTable from "./EntriesTable";

const Picks = ({ raceInfo, pickName, idPick, addToCart, entriesPicks }) => {
  let tablesPicks = [];

  // order races for race number
  entriesPicks.sort((a, b) => (a[0].RaceNumber < b[0].RaceNumber ? -1 : 0));

  entriesPicks &&
    entriesPicks.forEach((element, index) => {
      tablesPicks.push(
        <div key={index} style={{ borderTop: "1px solid #dee2e6" }}>
          <span
            style={{
              color: "#005580",
              fontFamily: "fantasy",
              fontSize: "20px",
            }}
          >
            R{element[0].RaceNumber}
          </span>
          <EntriesTable
            raceInfo={raceInfo}
            entriesInfo={element}
            wt={pickName}
            idWT={idPick}
            addToCart={addToCart}
            pickName={pickName}
            positionLeg={index}
            raceID={element[0].RaceID}
          />
        </div>
      );
    });

  return (
    <>
      <div
        className="tab-pane fade show active"
        id={pickName}
        role="tabpanel"
        aria-labelledby={pickName}
      >
        <div className="wrapper">{tablesPicks}</div>
      </div>
    </>
  );
};

export default Picks;
